import { render, staticRenderFns } from "./camera.vue?vue&type=template&id=3c50b4b6&scoped=true"
import script from "./camera.vue?vue&type=script&lang=js"
export * from "./camera.vue?vue&type=script&lang=js"
import style0 from "./camera.vue?vue&type=style&index=0&id=3c50b4b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c50b4b6",
  null
  
)

export default component.exports